<div class="flyout-upgrade-account-component">
  <div class="flyout-headline-row">
    <div class="headline-title">
      <span>{{ "subscription.new-usage.your-plan" | translate }}</span>
    </div>
    <div class="header-close-icon">
      <mat-icon class="close-icon" (click)="cancelFlyout()">close</mat-icon>
    </div>
  </div>

  <div class="flyout-upgrade-content">
    <div class="flyout-upgrade-section">
      <app-upgrade-tier [tier]="currentCustomer.tier" [allowDowngrade]="allowDowngrade" (tierChange)="switchTier($event)"></app-upgrade-tier>
    </div>
    @if (currentTrafficLevel) {
      <div class="flyout-upgrade-section">
        <div class="flyout-upgrade-section-row label">
          <span>{{ "generic.traffic" | translate }}</span>
          <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.traffic)">help_outline</mat-icon>
        </div>
        @if (trafficLevelsMap) {
          <div class="flyout-upgrade-section-row value">
            @if (!!trafficLevelsMap[currentTrafficLevel]) {
              <span class="value-number">{{ trafficLevelsMap[currentTrafficLevel] | toLocaleNumber }}</span>
              <span class="value-suffix">&nbsp;{{ "subscription.new-usage.pageviews-per-month" | translate }}</span>
            }
            @if (!trafficLevelsMap[currentTrafficLevel]) {
              <span [innerHTML]="'subscription.new-usage.contact-support' | translate"></span>
            }
          </div>
        }
        <div class="flyout-upgrade-section-row slider">
          <mat-slider class="flyout-upgrade-section-row-slider" [min]="1" [max]="trafficLevelsCount" #ngSlider>
            <input
              matSliderThumb
              [value]="currentTrafficLevel"
              (input)="trafficLevelChanged({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
              #ngSliderThumb="matSliderThumb" />
          </mat-slider>
        </div>
        @if (showTrafficDowngradeWarning) {
          <div class="downgrade-warning">
            <p>{{ "subscription.new-usage.traffic-downgrade-warning" | translate }}</p>
          </div>
        }
      </div>
    }

    <div class="flyout-upgrade-section accounts">
      <div class="flyout-upgrade-section-row label">
        <span>{{ "subscription.new-usage.accounts" | translate }}</span>
        <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.accounts)">help_outline</mat-icon>
      </div>
      <div class="flyout-upgrade-section-row accounts">
        <mat-form-field class="new-style-input small-input-field" appearance="outline">
          <input
            matInput
            [(ngModel)]="currentAccountsLevel"
            name="accountsLevel"
            #accountsLevelInput="ngModel"
            type="number"
            min="1"
            [max]="maxAccountsLevel"
            (change)="accountsLevelChanged({ value: currentAccountsLevel })" />
          @if (accountsLevelInput?.errors?.max) {
            <mat-error>{{ "generic.validation.max-min-number" | translate: { min: 1, max: 30 } }}</mat-error>
          }
        </mat-form-field>
        <span>{{ "subscription.new-usage.same-brand-and-domain" | translate }}</span>
      </div>
    </div>

    <div class="flyout-upgrade-addons-section">
      <div class="flyout-upgrade-section">
        <div class="flyout-upgrade-section-row label">
          <span>{{ "subscription.new-usage.surveys" | translate }}</span>
          <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.surveyResponses)">help_outline</mat-icon>
        </div>
        <div class="flyout-upgrade-section-row value">
          @if (surveyResponsesLevelsCount !== currentSurveyResponsesLevel) {
            <span class="value-number">{{ getCurrentSurveyResponsesPerMonthOrDefaultLimit() | toLocaleNumber }}</span>
            @if (currentSurveyResponsesLevel !== 1) {
              <span class="value-suffix">&nbsp;{{ "subscription.new-usage.survey-responses-per-month-extra" | translate }}</span>
            }
            @if (currentSurveyResponsesLevel === 1) {
              <span class="value-suffix">&nbsp;{{ "subscription.new-usage.survey-responses-per-month" | translate }}</span>
            }
          }
          @if (surveyResponsesLevelsCount === currentSurveyResponsesLevel) {
            <span>{{ "subscription.new-usage.unlimited" | translate }} {{ "subscription.new-usage.survey-responses-per-month" | translate }}</span>
          }
        </div>
        <div class="flyout-upgrade-section-row slider">
          <mat-slider
            [class.thumb-offset]="currentSurveyResponsesLevel === 1"
            class="flyout-upgrade-section-row-slider"
            [min]="1"
            [max]="surveyResponsesLevelsCount"
            #ngSlider>
            <input
              matSliderThumb
              [value]="currentSurveyResponsesLevel"
              (input)="surveyResponsesLevelChanged({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
              #ngSliderThumb="matSliderThumb" />
          </mat-slider>
        </div>
      </div>
      @if (showSurveyWarning) {
        <div class="survey-warning">
          <p>{{ "subscription.new-usage.survey-warning" | translate }}</p>
        </div>
      }
    </div>

    <div class="flyout-upgrade-section">
      <div class="flyout-upgrade-section-row label">
        <span>{{ "subscription.new-usage.billing-frequency.title" | translate }}</span>
        <mat-icon class="explainer" (click)="explainerDialogService.setContentExpainer(EXPLAINER_TEXTS.frequency)">help_outline</mat-icon>
      </div>
      <mat-radio-group class="flyout-upgrade-section-row-frequency" (change)="sendRecalculationRequest()" [(ngModel)]="currentBillingFrequency">
        <mat-radio-button [value]="SubscriptionFrequency.Year">
          <span>{{ "subscription.new-usage.billing-frequency.Year" | translate }}&nbsp;&nbsp;</span>
          <span class="highlighted-text">{{ "subscription.new-usage.billing-frequency.save-on-yearly" | translate }}</span>
        </mat-radio-button>
        <mat-radio-button [value]="SubscriptionFrequency.Month">
          <span>{{ "subscription.new-usage.billing-frequency.Month" | translate }}</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="flyout-upgrade-section">
      <div class="flyout-upgrade-section-row label">
        <span>{{ "generic.currency" | translate }}</span>
      </div>
      @if (provider === SubscriptionProvider.Shopify) {
        <div class="flyout-upgrade-section-row value">
          <span class="value-number">{{ currentCurrency | uppercase }}</span>
          <span class="value-suffix">&nbsp;{{ "subscription.shopify.currency-from-shop" | translate }}</span>
        </div>
      } @else {
        <mat-form-field
          appearance="outline"
          class="flyout-upgrade-section-field-currency"
          [matTooltip]="subscriptionExists ? ('subscription.new-usage.currency-tooltip' | translate) : null">
          <mat-select [(ngModel)]="currentCurrency" (ngModelChange)="recalculatePrice()" [disabled]="subscriptionExists">
            @for (currency of currencyOptions; track currency) {
              <mat-option [value]="currency">
                <span>{{ currency | uppercase }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>

    @if (subscriptionExists && provider === SubscriptionProvider.Shopify) {
      <div class="flyout-upgrade-section">
        <div class="flyout-upgrade-replacement-notice">
          <mat-icon class="notice-icon">info</mat-icon>
          <span>{{ "subscription.shopify.replacement-notice" | translate }}</span>
        </div>
      </div>
    }

    <div class="flyout-upgrade-section">
      <div class="flyout-upgrade-section-row label">
        <span [innerHTML]="'subscription.new-usage.questions' | translate"></span>
      </div>
    </div>

    <div class="flyout-upgrade-section price">
      <div class="flyout-upgrade-section-row label">
        <span>{{ "subscription.new-usage.total-price" | translate }}:&nbsp;</span>
        @if (showContactSales !== true && loadingCalculation !== true) {
          @if (currentBillingFrequency === SubscriptionFrequency.Month && !monthlyPriceFromYear) {
            <span class="price-value">
              @if (discount) {
                <s class="list-price">{{ calculatedPrice | toLocaleNumber }}</s>
                {{ discountedPrice | toLocaleNumber: discountedPriceDigitsInfo }}&nbsp;{{ "subscription.new-usage.price." + currentCurrency | translate }}&nbsp;
              } @else {
                {{ calculatedPrice | toLocaleNumber }}&nbsp;{{ "subscription.new-usage.price." + currentCurrency | translate }}&nbsp;
              }
            </span>
            <span>/ {{ "subscription.new-usage.billing-frequency." + currentBillingFrequency | translate }}</span>
          } @else if (currentBillingFrequency !== SubscriptionFrequency.Month && monthlyPriceFromYear) {
            <!-- Shopify approves the annual total, so that headlines. The monthlyPriceFromYear guard above is what stops
                       the 500 ms price debounce rendering a monthly figure labelled "/ year". -->
            @if (provider === SubscriptionProvider.Shopify) {
              <span class="price-value">
                {{ calculatedPrice | toLocaleNumber }}&nbsp;{{ "subscription.new-usage.price." + currentCurrency | translate }}&nbsp;
              </span>
              <span>/ {{ "generic.year" | translate }}</span>
              &nbsp;
              <span>
                ({{ monthlyPriceFromYear | toLocaleNumber }}&nbsp;{{ "subscription.new-usage.price." + currentCurrency | translate }} /
                {{ "generic.month" | translate }})
              </span>
            } @else {
              <span class="price-value">
                @if (discount) {
                  <s class="list-price">{{ monthlyPriceFromYear | toLocaleNumber }}</s>
                  {{ discountedMonthlyPriceFromYear | toLocaleNumber }}&nbsp;{{ "subscription.new-usage.price." + currentCurrency | translate }}&nbsp;
                } @else {
                  {{ monthlyPriceFromYear | toLocaleNumber }}&nbsp;{{ "subscription.new-usage.price." + currentCurrency | translate }}&nbsp;
                }
              </span>
              <span>/ {{ "generic.month" | translate }}</span>
              &nbsp;
              <span>({{ "subscription.new-usage.yearly-payment" | translate }})</span>
            }
          } @else {
            {{ "subscription.new-usage.calculating" | translate }}
          }
        }
        @if (showContactSales !== true && loadingCalculation === true) {
          <span>{{ "subscription.new-usage.calculating" | translate }}</span>
        }
        @if (showContactSales === true) {
          <span [innerHTML]="'subscription.new-usage.contact-sales' | translate"></span>
        }
      </div>
      @if (discount && showContactSales !== true) {
        <span class="discount-info" data-test="upgrade-discount">
          {{
            discountTranslationKey
              | translate
                : {
                    percent: discount.percentOff,
                    amount: (discount.amountOff | toLocaleNumber),
                    currency: ("subscription.new-usage.price." + currentCurrency | translate),
                    date: (discount.endDate | date),
                  }
          }}
        </span>
      }
      @if (taxLocationCountry === "SE") {
        <span class="tax">{{ "subscription.new-usage.tax-info" | translate }}</span>
      }
    </div>

    <div class="flyout-upgrade-section">
      <div class="flyout-upgrade-section-row label">
        <mat-slide-toggle [checked]="policyAccepted" (change)="togglePolicy({ data: { policyAccepted: $event.checked } })"></mat-slide-toggle>
        <span class="terms-text" [innerHTML]="'subscription.new-usage.approve-policy' | translate"></span>
      </div>
    </div>
  </div>

  <div class="flyout-bottom-row">
    <div class="button-wrapper">
      <button class="secondary-button" mat-stroked-button (click)="cancelFlyout()">
        <span class="btn-label">{{ "generic.cancel" | translate | uppercase }}</span>
      </button>
    </div>
    <div class="button-wrapper" [matTooltip]="disableSaveTooltip | translate" [matTooltipDisabled]="disableSaveTooltip === undefined">
      <button class="primary-button" mat-stroked-button [disabled]="isSaveDisabled" (click)="savePriceCalculation()">
        @if (saveInProgress || checkoutInProgress) {
          <mat-spinner class="spinner" [diameter]="18" [mode]="'indeterminate'" [class.inProgress]="saveInProgress || checkoutInProgress"></mat-spinner>
        }
        @if (subscriptionExists) {
          <div>
            <span class="btn-label">{{ "generic.save" | translate | uppercase }}</span>
          </div>
        } @else {
          <span class="btn-label">{{ "generic.saveAndContinue" | translate | uppercase }}</span>
        }
      </button>
    </div>
  </div>
</div>
